import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router, Event, NavigationEnd } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'ew-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent {
  showBtnBack: boolean = true;
  showCover: boolean = true;
  userInactivity: string | null = sessionStorage.getItem('userInactivity');

  constructor(
    public LOCATION: Location,
    private RT: Router,
    public AUTH: AuthService,
  ) {
    this.RT.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.showBtnBack = event.url != '/';
      }
    });

    sessionStorage.removeItem('userInactivity');
  }

  signIn(): void {
    // this.auth.logout()
    this.AUTH.loginWithRedirect();
    // this.RT.navigate(['/verification-account-fill-the-code']);
  }

  signUp(): void {
    // this.auth.logout()
    this.AUTH.loginWithRedirect({
      appState: {
        target: '/profile',
      },
      authorizationParams: {
        screen_hint: 'signup',
      },
    });
    // this.RT.navigate(['/verification-account-fill-the-code']);
  }
}
